// removed by extract-text-webpack-plugin
module.exports = {"typeahead":"typeahead","input":"input","suggestions":"suggestions","suggestion":"suggestion","selected":"selected","ticker":"ticker","loading":"loading"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/HoldingsEditor/Typeahead/Typeahead.css
// module id = 756
// module chunks = 0